import { ApiResource } from '@/core/models/api-resource.interface';
import { LocationQuery } from 'vue-router';
import { User } from '../../users/user.interface';

export class UserService {
   async getTaskUsers(search?: LocationQuery, query?: LocationQuery) {
      const response = await http.get<ApiResource<Array<User>>>(`/tasks/users`, { params: { ...query, 'filter[name]': search } });
      return response.data;
   }

   async getTaskUsersByTaskId(taskId: number, search?: LocationQuery, query?: LocationQuery) {
      const response = await http.get<ApiResource<Array<User>>>(`/tasks/${taskId}/users`, { params: { ...query, 'filter[name]': search } });
      return response.data;
   }
}
